<template>
    <div>

        <b-container fluid>  
            <b-row>
                <b-col>
                    <img src = "../assets/TOS-1.jpg">
                    <img src = "../assets/TOS-2.jpg">
                    <img src = "../assets/TOS-3.jpg">
                    <img src = "../assets/TOS-4.jpg">     
                </b-col>
            </b-row>   
            <b-row>
                <b-col><small>By signing up, you agree to receive occasional marketing emails. You can opt out anytime.</small></b-col>    
            </b-row>    
        </b-container>
    </div>
</template>

<script>
    export default {
    }
</script>